import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerDashboard } from '@js/api/types/customer/CustomerDashboard'

interface GetCustomerDashboardResponse {
  data: {
    wceiGetCustomerDashboard: CustomerDashboard | null
  }
  errors?: [{ message: string }]
}

export const customerDashboardQuery = gql`
  query wceiGetCustomerDashboard {
    wceiGetCustomerDashboard {
      registrations {
        registration_id
        registration_number
        craft_entry_id
        status
        attestation
        expiration_date
        completed_date
        personal {
          address
          address_two
          city
          state
          country
          postcode
          phone
          secondary_phone
        }
        professional {
          licenses {
            license_id
            license_number
            license_type
            license_state
          }
          primary_employment
          employer_name
          employer_city
          employer_state
          hear_about
          certifications
        }
        item {
          sku
          course_option
        }
      }
      alumni {
        wcc_alumni
        oms_alumni
        dwc_alumni
      }
      payment_history {
        order_id
        increment_id
        purchase_date
        product_name
        grand_total
        status
      }
    }
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const getCustomerDashboard = async (): Promise<CustomerDashboard | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<GetCustomerDashboardResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: customerDashboardQuery,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.wceiGetCustomerDashboard) {
    return data.data.wceiGetCustomerDashboard
  }

  return null
}
